"use client";

import React from "react";

export function Faq13() {
  return (
    /* bg-wood-green = tvoje zelená, text-white = bílá pro čitelnost */
    <section id="faq" className="bg-wood-green text-white font-sans px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container mx-auto">
        
        {/* Hlavní nadpis sekce - Gelasio */}
        <div className="mb-12 w-full max-w-2xl md:mb-18 lg:mb-20">
          <h2 className="mb-5 text-[40px] font-bold font-serif leading-[1.1] md:mb-6 md:text-[56px] lg:text-[64px]">
            Často kladené dotazy
          </h2>
          <p className="text-base md:text-lg opacity-90">
            Odpovědi na to, co vás zajímá o našem řemesle
          </p>
        </div>

        {/* Mřížka s dotazy */}
        <div className="grid grid-cols-1 gap-10 gap-y-12 md:grid-cols-3 md:gap-x-8 md:gap-y-16 lg:gap-x-12">
          
          <div>
            <h3 className="mb-3 text-xl font-bold font-serif md:mb-4 md:text-2xl">
              Jak dlouho trvá stavba?
            </h3>
            <p className="text-base leading-[1.6] opacity-80">
              Záleží na projektu. Malá obnova trvá měsíce, nový dům rok či dva.
              Nespěcháme. Děláme to správně.
            </p>
          </div>

          <div>
            <h3 className="mb-3 text-xl font-bold font-serif md:mb-4 md:text-2xl">
              Pracujete v chráněných krajinách?
            </h3>
            <p className="text-base leading-[1.6] opacity-80">
              Ano. Máme zkušenost s úřady na ochranu přírody a památek. Víme,
              jaké jsou požadavky, a respektujeme je.
            </p>
          </div>

          <div>
            <h3 className="mb-3 text-xl font-bold font-serif md:mb-4 md:text-2xl">
              Jaké dřevo používáte?
            </h3>
            <p className="text-base leading-[1.6] opacity-80">
              Vybíráme podle projektu a místa. Často jde o smrk nebo jedle.
              Důležité je kvalita a původ materiálu.
            </p>
          </div>

          <div>
            <h3 className="mb-3 text-xl font-bold font-serif md:mb-4 md:text-2xl">
              Můžete obnovit starý dům?
            </h3>
            <p className="text-base leading-[1.6] opacity-80">
              Je to naše specialita. Starý dům má svou logiku. Učíme se ji číst
              a respektovat ji při obnově.
            </p>
          </div>

          <div>
            <h3 className="mb-3 text-xl font-bold font-serif md:mb-4 md:text-2xl">
              Jaká je vaše záruka?
            </h3>
            <p className="text-base leading-[1.6] opacity-80">
              Stavíme tak, aby to vydrželo. Záruka je v tom, jak pracujeme, a v
              tom, že se za svou prací postavíme.
            </p>
          </div>

          <div>
            <h3 className="mb-3 text-xl font-bold font-serif md:mb-4 md:text-2xl">
              Napište nám nebo zavolejte.
            </h3>
            <p className="text-base leading-[1.6] opacity-80">
              Čas není nepřítel, je součást procesu. Malá oprava trvá týdny,
              nový dům roky. Nespěcháme, protože spěch kazí dřevo i řemeslo.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}